import { combineEpics } from 'redux-observable';
import { updateOwnershipEpic } from './update-ownership';
import { createOwnershipEpic } from './create-ownership';
import { getOwnershipsEpic } from './get-ownerships';
import { removeOwnershipEpic } from './remove-ownership';
import { removeManagerOwnershipEpic } from './remove-manager-ownership';
import { autosaveEpic } from './autosave';
import { reassignSplitsEpic } from './reassign-splits';
import { updateRequestSplitEpic } from './update-request-split';
import { createOwnersForNewMerchEpic } from './create-owners-for-new-merch';
import { createOwnerForSongwriter } from './create-owner-for-songwriter';
import { getOwnershipForTrackEpic } from './get-ownership-for-track';
import { updateOwnershipOrderEpic } from './update-ownership-order';
import { getOwnershipAfterCollaboratorCreateEpic } from './get-ownerships-after-collaborator-create';
import { createOwnerAfterLabelEdition } from './create-owner-after-label-edition';
import { getOwnershipsByUserIdEpic } from './get-ownerships-by-use-Id';
import { saveAssetOwnershipsEpic } from './save-asset-ownerships';

const ownershipEpic = combineEpics(
  autosaveEpic,
  getOwnershipsEpic,
  getOwnershipsByUserIdEpic,
  getOwnershipForTrackEpic,
  createOwnershipEpic,
  updateOwnershipEpic,
  reassignSplitsEpic,
  updateRequestSplitEpic,
  removeOwnershipEpic,
  removeManagerOwnershipEpic,
  createOwnersForNewMerchEpic,
  createOwnerForSongwriter,
  getOwnershipAfterCollaboratorCreateEpic,
  createOwnerAfterLabelEdition,
  updateOwnershipOrderEpic,
  saveAssetOwnershipsEpic
);

export default ownershipEpic;
